import { render, staticRenderFns } from "./bulma_tabprops.vue?vue&type=template&id=8db96dde&scoped=true&lang=html"
import script from "./bulma_tabprops.vue?vue&type=script&lang=js"
export * from "./bulma_tabprops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db96dde",
  null
  
)

export default component.exports